import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "动漫资讯", to: "/news" },
  { label: "作品推荐", to: "/recommend" },
  { label: "专题合集", to: "/special" },
  { label: "关于我们", to: "/about" },
];

const socialLinks = [
  { label: "微博", icon: "ri-weibo-fill", href: "#" },
  { label: "哔哩哔哩", icon: "ri-bilibili-fill", href: "#" },
  { label: "公众号", icon: "ri-wechat-fill", href: "#" },
  { label: "邮箱", icon: "ri-mail-fill", href: "mailto:hello@91anime.demo" },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-secondary-950 text-secondary-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-extrabold text-white">
                91
              </span>
              <span className="font-heading text-xl font-extrabold text-white">动漫</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-200/90">
              91动漫是面向广大动漫爱好者的资讯门户，汇聚最新动漫动态、精彩作品介绍与观看指南，帮助你轻松了解热门动漫、发现优质内容。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {socialLinks.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  aria-label={s.label}
                  title={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/10 text-secondary-100 transition-colors hover:bg-primary-500 hover:text-white"
                >
                  <i className={`${s.icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-white">快速导航</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="whitespace-nowrap text-sm text-secondary-200/90 transition-colors hover:text-primary-300"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-white">内容范围</h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-secondary-200/90">
              <li>动漫新闻与动态</li>
              <li>作品资料与推荐</li>
              <li>专题合集与片单</li>
              <li>观看 / 追番指南</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-secondary-300/80">
            © 2026 91动漫 · 本站内容均为演示用途，与任何真实作品或品牌无关。
          </p>
          <p className="text-xs text-secondary-300/80">播放与下载功能暂未接入，不在演示范围内。</p>
        </div>
      </div>
    </footer>
  );
}